/**
 * Build provenance — baked in at Vite build time via `define` in
 * vite.config.js.  Public-facing only: the semver tag + the build
 * timestamp.
 *
 * Deliberately NOT exposed: git SHA, commit URL, CI run id, repo
 * name.  This is a paid product; internal commit identifiers stay
 * in CI logs, never in the bundle the customer downloads.  Anyone
 * who needs to debug a specific deploy looks at the server-side
 * request id (already returned on every API response envelope).
 *
 * Card 093.
 */

/* global __SPOTLIGHT_BUILD_VERSION__, __SPOTLIGHT_BUILD_TIME__ */

export const BUILD_INFO = {
  version:
    typeof __SPOTLIGHT_BUILD_VERSION__ === 'string'
      ? __SPOTLIGHT_BUILD_VERSION__
      : 'dev',
  time:
    typeof __SPOTLIGHT_BUILD_TIME__ === 'string'
      ? __SPOTLIGHT_BUILD_TIME__
      : '',
};

/**
 * Compact one-line label suitable for UserMenu footer.
 *   "v0.0.1"
 *   "dev"
 */
export function buildLabel() {
  return BUILD_INFO.version;
}

// Install the devtools global on import so support can ask the
// customer to paste `__SPOTLIGHT_BUILD` and we get the version
// they're on without ambiguity.  Still no SHA / no repo link.
if (typeof window !== 'undefined') {
  window.__SPOTLIGHT_BUILD = BUILD_INFO;
}
